export const KIOSK_SESSION_KEY = "muhasabaty:customer-kiosk-company";

export function getActiveKioskCompany() {
  try { return window.sessionStorage.getItem(KIOSK_SESSION_KEY) || ""; }
  catch { return ""; }
}

export function setActiveKioskCompany(companyId) {
  try {
    if (companyId) window.sessionStorage.setItem(KIOSK_SESSION_KEY, String(companyId));
  } catch { /* The public kiosk still works if browser storage is restricted. */ }
}
